export enum ActionType {
  Mail = 1,
  TextMessage = 2,
}
